import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { MdDeleteForever } from 'react-icons/md';
import { FaRegEdit } from 'react-icons/fa';
import TableComponent from '../../pages-parts/table/TableComponent';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Entries from '../../pages-parts/table/Entries';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CreateNewModal from '../../pages-parts/table/CreateNewModal';


const StyledRules = styled.div`
    position: relative;
    width: 100%;
    transition: all .5s ease-in-out;
    padding: 2.5rem 1.75rem;
    .scroll-thumb{
        background-color: ${({ theme }) => theme.colors.primary_8};
    }
`;

const RulesPage = () => {
    const location = useLocation();
    const [showEditModal, setShowEditModal] = useState(false);
    const [editModalValue, setEditModalValue] = useState({
        id: "",
        ruleName: ""
    });
    const [columns, setColumns] = useState([
        {
            id: 1,
            Header: "#",
            Cell: e => {
                return <span className='numbers-font'>{e.value}</span>
            },
            accessor: "number",
            sortable: true,
        },
        {
            id: 2,
            Header: "الدور",
            accessor: "trans",
            sortable: true,
            Cell: e => {
                return (
                    <div id={e.row.cells.find(cell => cell.column.Header === "الاجراءات").value}>
                        {e.value}
                    </div>
                )
            }
        },
        {
            id: 3,
            Header: "الاجراءات",
            accessor: "id",
            sortable: false,
            Cell: e => {
                return (
                    <div>
                        <OverlayTrigger
                            key="edit"
                            placement="bottom"
                            overlay={
                                <Tooltip id={`tooltip-edit`}>
                                    تعديل الدور
                                </Tooltip>
                            }
                        >
                            <span className='edit-modal' onClick={() => handleEditTerm(e.value)}><FaRegEdit /></span>
                        </OverlayTrigger>
                    </div>
                )
            }
        },
    ]);
    const [sortTable, setSortTable] = useState(() => {
        const filterStorage = JSON.parse(localStorage.getItem(location.pathname + '-filters')) ?? null;
        if (filterStorage !== null && filterStorage.sortFilter !== undefined) {
            return filterStorage.sortFilter;
        } else {
            return {
                column: '',
                direction: ''
            };
        }
    });
    const [pageNum, setPageNum] = useState(() => {
        return JSON.parse(localStorage.getItem(location.pathname + '-page-num')) ?? 1;
    });
    const [entries, setEntries] = useState(() => {
        return JSON.parse(localStorage.getItem('entries-per-page')) ?? 10;
    })
    const [tableDataUrl, setTableDataUrl] = useState(() => {

        // sort filter url part
        let sortFilter;
        if (sortTable.column !== "" && sortTable.column !== undefined) {
            sortFilter = `_sort=${sortTable.column}&_order=${sortTable.direction}&`;
        } else {
            sortFilter = "";
        }

        const url = `/rules?${sortFilter}&_page=${pageNum}&_limit=${entries}`;

        return url;
    })

    useEffect(() => {

        // sort filter url part
        let sortFilter;
        if (sortTable.column !== "" && sortTable.column !== undefined) {
            sortFilter = `_sort=${sortTable.column}&_order=${sortTable.direction}&`;
        } else {
            sortFilter = "";
        }

        const url = `/rules?${sortFilter}&_page=${pageNum}&_limit=${entries}`;
        setTableDataUrl(url);
    },
        [
            sortTable,
            pageNum,
            entries,
        ]
    );

    useEffect(() => {
        const localFilter = {
            sortFilter: sortTable,
        }
        localStorage.setItem(location.pathname + '-page-num', pageNum);
        localStorage.setItem('entries-per-page', entries);
        localStorage.setItem(location.pathname + '-filters', JSON.stringify(localFilter));

    }, [tableDataUrl]);

    const handleEditTerm = (id) => {
        setShowEditModal(true);
        const rule = document.getElementById(id).innerText;
        setEditModalValue({
            id,
            ruleName: rule
        })
    }
    const handleClose = () => {
        setShowEditModal(false);
    }
    const handleSave = () => {
        const rule = document.getElementById(editModalValue.id);
        rule.innerText = editModalValue.ruleName;
        setShowEditModal(false);
    }
    return (
        <StyledRules>
            <Container fluid>
                <Row className='mb-3 flex-lg-row-reverse flex-md-row justify-content-between'>
                    <Col
                        md={5}
                        sm={12}
                        className='d-flex justify-content-end align-items-center mb-2'
                    >
                        <Entries
                            entries={entries}
                            setEntries={setEntries}
                        />
                    </Col>
                    <Col md={5} sm={12}>
                        <CreateNewModal
                            text='إضافة دور'
                            modleContent={{
                                title: 'إضافة دور',
                                inputName: 'rule',
                                inputPlaceholder: 'اسم الدور'
                            }}
                        />
                    </Col>
                </Row>
                <TableComponent
                    columns={columns}
                    tableDataUrl={tableDataUrl}
                    setSortTable={setSortTable}
                    tableWidth={800}
                    setPageNum={setPageNum}
                    pageNum={pageNum}
                    tableRowsPerPage={entries}
                />
                <Modal show={showEditModal} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>تعديل الدور</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Control
                            className='py-2 px-3'
                            type='text'
                            name="edit-rule"
                            placeholder="اسم الدور"
                            value={editModalValue.ruleName}
                            onChange={(e) => setEditModalValue(prev => {
                                return {
                                    ...prev,
                                    ruleName: e.target.value
                                }
                            })}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            اغلاق
                        </Button>
                        <Button variant="primary" onClick={handleSave}>
                            حفظ
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        </StyledRules>
    );
}

export default RulesPage;